import { TOGGLE_LVZ_SPECIFIC_DETAIL_PANEL } from "./displayLvzSpecificDetailPanelReducer"

export const toggleLvzSpecificDetailPanel = (value) => ({
    type: TOGGLE_LVZ_SPECIFIC_DETAIL_PANEL,
    payload: value
})